import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

interface DialogCloseButtonProps {
    onClick: () => void,
    disabled?: boolean
}

export const DialogCloseButton = (props: DialogCloseButtonProps) => {
    return (
        <IconButton
            sx={{
                position: 'absolute',
                top: 12,
                right: 12
            }}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            <Close fontSize="inherit"/>
        </IconButton>
    );
};

export default DialogCloseButton;